define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/table/Copy",
	"./ContractualDocumentFormActionMixin",
	"csi/xml"
], function(declare,lang,Copy,ContractualDocumentFormActionMixin,xml) {

	return declare([ Copy, ContractualDocumentFormActionMixin ], {
		toWriterFields: function(/*String*/urlNode, /*FormData?*/fd) {
			this._adjustSaveScript(urlNode, fd);
			this.inherited(arguments);
		}
	});
});
